// @ts-nocheck
import { getCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import siteMessage from "@insite/client-framework/SiteMessage";
import { chain, Validate } from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ValidateReCaptcha";
import { ReCaptchaParameters } from "@store/Overrides/Components/ReCaptcha";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

replaceInChain(chain, Validate, props => {
    const grecaptcha = (window as { [key: string]: any })["grecaptcha"];
    if (grecaptcha === undefined) {
        return;
    }

    const { ref, id = "reCaptcha" } = (props.parameter as ReCaptchaParameters) || {}; // Valtech Custom Code
    const reCaptchaElement = document.getElementById(id); // Valtech Custom Code

    if (!reCaptchaElement) {
        return;
    }

    if (getCookie("g-recaptcha-verified")) {
        return;
    }

    /*  Valtech Custom Code */
    let currentReCaptchaIndex: number | undefined;
    if (ref?.current) {
        const refCurrentId = (ref.current as any).id; // id property exists but is private
        const reCaptchas = document.getElementsByClassName("g-recaptcha");
        const index = Array.from(reCaptchas).findIndex(x => x.getAttribute("id") === refCurrentId);
        if (index !== -1) {
            currentReCaptchaIndex = index;
        }
    }
    /* Valtech Custom Code */

    const reCaptchaResponse = grecaptcha.getResponse(currentReCaptchaIndex); // Valtech Custom Code
    setCookie("g-recaptcha-response", reCaptchaResponse);
    props.errorMessage = reCaptchaResponse ? "" : (siteMessage("ReCaptcha_RequiredErrorMessage") as string);
    props.dispatch({
        type: "Components/ReCaptcha/SetErrorMessage",
        errorMessage: props.errorMessage,
    });
});
